//#region imports
import React, { useState, useMemo, useContext } from "react";

// bootstrap
import Carousel from 'react-bootstrap/Carousel';

// redux
import { useSelector } from "react-redux";
import { selectTaskByEmployeeAndColumn } from "_redux/slices/timeline/timeline-data";

// shared context from EmployeeList — subscribed once, avoids per-cell Redux subscriptions
import { JobListSharedContext } from "../employee-components/employee-list";

// styling
import "./job-list.css"
import JobCard from "./job-card";

//#endregion

const JobList = React.memo((props) => {

  //#region redux — shared values from context (single subscription in EmployeeList)
  const { thirtyMinLayout, selectedTask, selectedTasksList, usedTheme, selectedMultiplePAXTask, touchScreen } = useContext(JobListSharedContext) || {};

  const taskSelector = useMemo(
    () => selectTaskByEmployeeAndColumn(props?.employeeId, props?.timeIndex),
    [props?.employeeId, props?.timeIndex]
  );
  const taskList = useSelector(taskSelector);
  
  // const adhocTaskList = useSelector(selectAdhocTaskList);
  //#endregion

  // Adhoc tasks commented out
  const adhocTasks = []; // React.useMemo(() => {
  //   if (!adhocTaskList || !props?.employeeId || !props?.timeIndex) return [];
  //   return adhocTaskList.filter(task => {
  //     if (task?.employeeId !== props?.employeeId) return false;
  //     // Match assignedTime (HH:mm) to timeIndex (HH:mm)
  //     const assignedTime = task?.assignedTime || task?.adhocTaskInformation?.assignedTime;
  //     return assignedTime === props?.timeIndex;
  //   });
  // }, [adhocTaskList, props?.employeeId, props?.timeIndex]);

  // Debug logging for adhoc tasks - commented out
  // React.useEffect(() => {
  //   if (adhocTasks?.length > 0) {
  //   }
  //   // Log when we have adhoc tasks and this cell COULD match
  //   if (adhocTaskList?.length > 0) {
  //     adhocTaskList.forEach(task => {
  //       if (task?.employeeId === props?.employeeId && task?.assignedTime === props?.timeIndex) {
  //       }
  //     });
  //   }
  // }, [adhocTaskList, adhocTasks, props?.employeeId, props?.timeIndex]);
  
  //#region local states
  //const [jobs, setJobs] = useState([]);
  const [activeSlide, setActiveSlide] = useState(0);                  // holds value of active slide
  const [hoveredJobId, setHoveredJobId] = useState(null);
  
  // Track click order for dynamic z-index
  const [clickOrder, setClickOrder] = useState({});
  const [clickCounter, setClickCounter] = useState(1000); // Start high to override default z-index

  const handleCardClick = (jobId) => {
    setClickOrder(prev => ({
      ...prev,
      [jobId]: clickCounter
    }));
    setClickCounter(prev => prev + 1);
  };
  //#endregion

  //#region use effects

  // handle carousel select
  const handleSelect = (selectedIndex, event) => {
    // Stop the event from bubbling up to handleColumnClick
    event.stopPropagation();

    setActiveSlide(selectedIndex);
  };

  /* check if both task list and adhoc tasks are empty */
  if (!Array.isFullArray(taskList) && !Array.isFullArray(adhocTasks)) {
    return null;
  }

  //#endregion

  // Calculate total regular tasks for adhoc offset
  const regularTaskCount = taskList?.length || 0;

  // display list in carousel in 1 hour block view
  if(thirtyMinLayout){
    // display job list with dynamic cards and stacked z-index
    return (
      <div style={{ width:'100%', height:'100%' }}>
        {/* Regular tasks */}
        {taskList?.map((job, index) => (
          <div 
            key={index}
            onMouseEnter={() => setHoveredJobId(job?._id)}
            onMouseLeave={() => setHoveredJobId(null)}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: hoveredJobId === job?._id ? 1000 : 10 + index,
              marginTop: index * 22, 
              marginLeft: 0,
            }}
          >
            <JobCard
              job={job}
              index={index}
              disabled={props?.disabled}
              thirtyMinLayout={thirtyMinLayout}
              selectedTask={selectedTask}
              selectedTasksList={selectedTasksList}
              usedTheme={usedTheme}
              selectedMultiplePAXTask={selectedMultiplePAXTask}
              onCardClick={() => handleCardClick(job._id)}
            />
          </div>  
        ))}

      </div>
    )
  }
  // display list in carousel in 1 hour block view
  else {
    // Combine regular tasks and adhoc tasks for carousel
    const allTasks = [...(taskList || []), ...adhocTasks];
    
    return (
      <div className="carousel-wrapper">
        <Carousel
          activeIndex={activeSlide}
          onSelect={(selectedIndex, event) => handleSelect(selectedIndex, event)}
          interval={null}
          controls={!touchScreen}
        >
          {allTasks?.map((job, index) => (
            <Carousel.Item key={job?._id || index}>
              <JobCard
                job={job}
                index={index}
                disabled={props?.disabled}
                thirtyMinLayout={thirtyMinLayout}
                selectedTask={selectedTask}
                selectedTasksList={selectedTasksList}
                usedTheme={usedTheme}
                selectedMultiplePAXTask={selectedMultiplePAXTask}
                onCardClick={() => handleCardClick(job._id)}
              />
            </Carousel.Item>  
          ))}

        </Carousel>
      </div>
    )
  }

}, (prevProps, nextProps) => {
  // Custom comparison for React.memo - only re-render when these props change
  return prevProps.employeeId === nextProps.employeeId &&
         prevProps.timeIndex === nextProps.timeIndex &&
         prevProps.hour === nextProps.hour &&
         prevProps.disabled === nextProps.disabled &&
         prevProps.id === nextProps.id;
});

export default JobList;
